export const getNetworkErrorMessage = (status: boolean): string =>
	`З'єднання з мережею ${status ? 'відновлено' : 'втрачено'}`;
